import styledSystemShouldForwardProp from '@styled-system/should-forward-prop';
import type { StylesProps } from 'styled-system';
import { variant } from 'styled-system';

import type { FunctionInterpolation, VariantWithProp } from './types';

export const getVariantProp = <
  TComponentProps,
  K extends keyof TComponentProps & string,
>(
  params: VariantWithProp<K, Required<TComponentProps>[K]>
): FunctionInterpolation<TComponentProps> => variant(params);

type IntrinsicElementsTags = Extract<keyof JSX.IntrinsicElements, string>;
type IntrinsicElementKeys<Tag extends IntrinsicElementsTags> = Extract<
  keyof JSX.IntrinsicElements[Tag],
  string
>;

export const shouldForwardProp = <Tag extends IntrinsicElementsTags>(
  propName: string
): propName is Exclude<IntrinsicElementKeys<Tag>, keyof StylesProps> =>
  styledSystemShouldForwardProp(propName);
